
import subjects from '../../api/subjects'
import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'

// initial state
const state = {
    subjects: []
}

const actions = {
    [action_types.SUBJECTS_LOAD] (context, {schoolId, language}) { 
        subjects.getSubjects({schoolId, language}, loaded_subjects => {
            context.commit(mutation_types.SUBJECTS_SET, {subjects: loaded_subjects});
        });
    },
}

// mutations
const mutations = {
    [mutation_types.SUBJECTS_SET] (state, {subjects}) {
        state.subjects = subjects;
    },
    [mutation_types.SUBJECTS_ADD] (state, {subject}) {
        state.subjects.push(subject);
    },
}

export default {
    state,
    actions,
    mutations
}
